import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ChangeStatus } from '../Api/RestaurantApi/ReservationApi';

const SidebarItemResto = ({ i, selected, toogle, item }) => {
  const [open, setOpen] = useState(false);

  const restaurant = useSelector((state) => state.restaurant);

  const handleChangeStatus = () => {
    const data = { idRestaurant: restaurant.id };
    ChangeStatus(data).then(function (response) {
      if (response.data.title === "success") {
        console.log("Status a changer");
      }
    }).catch(function (error) {
      console.log(error.response);
    });
  }

  let location = useLocation();
  if (item.children) {
    return (
      <div className={selected === i ? 'sidebar-item open' : 'sidebar-item'} >
        <div className='sidebar-title' onClick={() => toogle(i)}>
          <span>
            <i className={item.icon}></i>
            {item.title}
          </span>
          <i className='fa fa-chevron-down toggle-btn'></i>
        </div>
        <div className="sidebar-content">
          {item.children.map((child, index) => {
            if (child.title === "Nouvelles résa") {
              return (
                <Link to={child.path || '#'} title={child.title} className={location.pathname === child.path ? 'sidebar-title active' : 'sidebar-title'} onClick={handleChangeStatus} key={index}>
                  <div className='d-flex'>
                    <i className={child.icon}></i>
                    <span>
                      {child.title}
                    </span>
                  </div>
                </Link>
              )
            } else {
              return (
                <Link to={child.path || '#'} title={child.title} className={location.pathname === child.path ? 'sidebar-title active' : 'sidebar-title'} key={index}>
                  <div className='d-flex'>
                    <i className={child.icon}></i>
                    <span>
                      {child.title}
                    </span>
                  </div>
                </Link>
              )
            }

          })}
        </div>
      </div>
    )
  } else {
    return (
      <Link to={item.path || '#'} onClick={() => toogle(i)} title={item.title} className={location.pathname === item.path ? 'sidebar-item active' : 'sidebar-item '}>
        <div className='sidebar-title'>
          <span>
            <i className={item.icon}></i>
            {item.title}
          </span>

        </div>
      </Link>
    )
  }

}

export default SidebarItemResto